// @flow

import React from 'react';
import Core from './../Core/Core';

type Props = {
  name?: string,
  onChange: Function,
};
type State = {
  name: ?string,
  matching: Array<Object>,
  isOpen: ?boolean,
  fetching: ?Object,
};

/**
 * Class permettant de faire l'autocomplète sur un nom de client
 */
class AutoComplete extends React.Component<Props, State> {
  static defaultProps = {
    name: '',
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      activeSuggestion: 0,
      name: props.name,
      matching: [],
      isOpen: false,
      fetching: null,
    };
    
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Le composant reçoit une nouvelle valeur
   */
  static getDerivedStateFromProps(props: Props, state: State) {
    const { name } = props;

    const newObject = {};
    let haveChanges = false;
    if (name && name !== state.name) {
      newObject.name = name;
      haveChanges = true;
    }

    if (haveChanges) {
      return newObject;
    }
    return null;
  }

  /**
   * Méthode permettant de mettre à jour le nom saisi
   */
  handleInputChange = (event: Object) => {
    const { onChange } = this.props;
    const { target } = event;
    const { value } = target;

    onChange({
      target: {
        name: 'name',
        value: value,
      },
    });
    onChange({
      target: {
        name: 'Client_id',
        value: null,
      },
    });

    this.setState(
      {
        name: value,
      },
      () => {
        // Plus de 3 caractères saisis, on appelle la prédiction
        if (value.length > 2) {
          this.getClients();
        } else {
          this.setState({
            activeSuggestion: 0,
            isOpen: false,
          });
        }
      },
    );
  };

  /**
   * Méthode permettant de contacter l'API
   */
  getClients = () => {
    const { name, fetching } = this.state;

    // Il y a déjà une requête en cours, on l'annule
    if (fetching) {
      fetching.cancel('Operation canceled by the user.');
    }

    // Il y a bien un nom de saisi
    if (name) {
      Core.Instance.Request(Core.Address + 'AutoComplete/?name=' + name, null, 'GET').then((predictions) => {
        this.setState({
          matching: predictions ? predictions : [],
          isOpen: true,
          activeSuggestion: 0,
          fetching: false,
        });
      }).catch((error) => {
        console.log(error)
      });
    }
  };

  
  handleClickOutside(event) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        activeSuggestion: 0,
        isOpen: false,
      });
    }
  }

  // Event fired when the user presses a key down
  onKeyDown = (e) => {
    const { activeSuggestion, name, matching, isOpen } = this.state;

    // User pressed the enter key, update the input and close the
    // suggestions
    if (e.keyCode === 13) {
      this.selectClient(matching[activeSuggestion]);
    }
    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === matching.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  /**
   * L'utilisateur sélectionne un client de la liste
   */
  selectClient = (item: Object) => {
    const { onChange } = this.props;
    if (item) {
      this.setState(
        {
          activeSuggestion: 0,
          name: item.first_name ? item.name + ' ' + item.first_name : item.name,
          isOpen: false,
        },
        () => {
          // On envoit le client sélectionnée à l'instance parente
          onChange({
            target: {
              name: 'name',
              value: item.first_name ? item.name + ' ' + item.first_name : item.name,
            },
          });
          onChange({
            target: {
              name: 'Client_id',
              value: item.id,
            },
          });
        },
      );
    }
  };

  /**
   * Méthode permettant d'afficher la liste des résultats
   */
  renderList() {
    const { activeSuggestion, matching, isOpen } = this.state;

    if (!isOpen || matching.length === 0) {
      return null;
    }

    return (
      <div className='autocomplete-results'>
        <ul className='list-group pl-0'>
          {matching.map((client, index) => (
            <li className={`list-group-item ${index === activeSuggestion ? 'active' : ''}`} onClick={() => this.selectClient(client)} key={client.id}>
              {client.name} {client.first_name}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  /**
   * Méthode permettant le rendu de l'instance
   */
  render() {
    const { name } = this.state;
    return (
      <div ref={this.wrapperRef}>
        <input
          type='text'
          value={name || ''}
          name='name'
          className='form-control'
          onChange={this.handleInputChange}
          onKeyDown={this.onKeyDown}
          autoComplete='off'
        />
        {this.renderList()}
      </div>
    );
  }
}

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/Components/AutoComplete.js